var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteBalladeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3364 12C26.3546 12 18.1787 -2.16107 11.1668 9.9793C18.1732 -2.16107 1.82131 -2.16107 8.83318 9.9793C1.8268 -2.16107 -6.34915 12 7.66362 12C-6.35464 12 1.82131 26.161 8.83318 14.0206C1.8268 26.161 18.1787 26.161 11.1668 14.0206C18.1732 26.1665 26.3491 12 12.3364 12Z",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBalladeIcon);
export default __webpack_public_path__ + "static/media/whiteBalladeIcon.35473c6c9cf4a5edbc351cd61133d2ac.svg";
export { ForwardRef as ReactComponent };